<template>
  <div>
    <v-btn
      class="v-tabs__markAsRead"
      text
      elevation="0"
      @click="expandMoreMenu"
    >
      Remind me later
    </v-btn>
    <v-expand-transition>
      <div
        v-if="showContextMenu"
        class="notificationsGroup__more--menu-context"
      >
        <v-list-item
          class="notificationsGroup__more--menu-item"
          @click="$emit('remindMeTomorrow', id, unread, tomorrow)"
        >
          <div class="notificationsGroup__more--menu-item__wrapper">
            <span class="notificationsGroup__more--menu-item__title">
              Tomorrow
            </span>
            <span class="notificationsGroup__more--menu-item__time">
              {{ this.tomorrowDay.name }} {{ this.tomorrowDay.time }}
            </span>
          </div>
        </v-list-item>
        <v-list-item
          class="notificationsGroup__more--menu-item"
          @click="$emit('remindMeNextWeek', id, unread, nextWeek)"
        >
          <div class="notificationsGroup__more--menu-item__wrapper">
            <span class="notificationsGroup__more--menu-item__title">
              Next week
            </span>
            <span class="notificationsGroup__more--menu-item__time">
              {{ this.nextWeekDay.name }} {{ this.nextWeekDay.time }}
            </span>
          </div>
        </v-list-item>
        <v-list-item
          class="notificationsGroup__more--menu-item"
          @click="$emit('remindMeAfterTenDays', id, unread, afterTenDays)"
        >
          <div class="notificationsGroup__more--menu-item__wrapper">
            <span class="notificationsGroup__more--menu-item__title">
              10 days
            </span>
            <span class="notificationsGroup__more--menu-item__time">
              {{ this.afterTenDaysDay.name }}
              {{ this.afterTenDaysDay.time }}
            </span>
          </div>
        </v-list-item>
        <v-list-item
          class="notificationsGroup__more--menu-item"
          @click.prevent.stop="$emit('toggleShowDatePickerHandler')"
        >
          <div class="notificationsGroup__more--menu-item__wrapper">
            <span class="notificationsGroup__more--menu-item__title">
              Select date
            </span>
          </div>
        </v-list-item>
      </div>
    </v-expand-transition>
  </div>
</template>
<script>
export default {
  name: 'NotificationsGroupMoreMenu',
  components: {},
  props: {
    id: {
      type: Number,
      default: 0,
    },
    unread: {
      type: Boolean,
      default: false,
    },
    tomorrow: {
      type: String,
      default: '',
    },
    nextWeek: {
      type: String,
      default: '',
    },
    afterTenDays: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      showContextMenu: false,
      tomorrowDay: {
        name: this.$moment()
          .add(1, 'days')
          .format('ddd'),
        time: '12:00',
      },
      nextWeekDay: {
        name: this.$moment()
          .add(7, 'days')
          .format('ddd'),
        time: '12:00',
      },
      afterTenDaysDay: {
        name: this.$moment()
          .add(10, 'days')
          .format('ddd'),
        time: '12:00',
      },
    }
  },
  computed: {},
  methods: {
    expandMoreMenu(e) {
      e.stopPropagation()
      this.$nextTick(() => {
        this.showContextMenu = !this.showContextMenu
      })
    },
  },
}
</script>

<style lang="scss">
.notificationsGroup {
  &__more {
    width: 32px;
    flex-shrink: 0;
    text-align: center;
    position: absolute;
    top: 4px;
    right: 0;
    opacity: 0;
    -webkit-transition-duration: 150ms;
    -moz-transition-duration: 150ms;
    -ms-transition-duration: 150ms;
    -o-transition-duration: 150ms;
    transition-duration: 150ms;
    .v-btn {
      padding: 0;
      background: $bh-blue--4;
      .v-icon {
        color: $bh-blue--3;
      }
      &:hover,
      &:focus {
        .v-icon {
          color: $bh-blue;
        }
      }
    }
    &--menu {
      width: 260px;
      .v-list-item__icon {
        margin-right: 12px !important;
        text-align: center;
        display: block;
        .v-icon {
          color: $bh-blue;
        }
      }
      .v-list-item__title {
        font-weight: bold;
        font-size: 1rem;
        color: $bh-blue;
      }
    }

    &--menu-context {
      background-color: $bh-white;
      box-shadow: rgba(0, 0, 0, 0.08) 0px 8px 24px 0px,
        rgba(0, 0, 0, 0.08) 0px 0px 2px 0px;
      border-radius: 16px;
      position: absolute;
      z-index: 99;
      width: 260px;
      right: 32px;
    }
    &--menu-item {
      padding: 0 24px 0 16px;
      transition: background-color 0.3s ease-in;
      cursor: pointer;
      &.v-list-item {
        &--link:before {
          background-color: $bh-white;
        }
      }
      &:hover {
        background-color: $bh-white;
      }
      &__wrapper {
        display: flex;
        justify-content: space-between;
        width: 100%;
      }
      &__title {
        font-size: 14px;
        font-weight: 600;
        color: $bh-black;
      }
      &__time {
        font-size: 12px;
        font-weight: 300;
        color: $bh-black;
      }
    }
  }
}
</style>
